import state from './moduloTemplatesState';
import mutations from './moduloTemplatesMutations';
import actions from './moduloTemplatesActions';
import getters from './moduloTemplatesGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
